import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import { Link, useLocation } from "react-router-dom";
import type { Notification } from "~types/notification";
import PopoverNotificationItem from "./components/PopoverNotificationItem";

import "./NotificationsPopoverContent.scss";

type Props = {
  notifications: Notification[];
  unreadCount: number;
  notificationsUrl: string;
  onClose: () => void;
  onNotificationClick: (notification: Notification) => void;
};

const NotificationsPopoverContent = ({ notifications, unreadCount, notificationsUrl, onClose, onNotificationClick }: Props) => {
  const location = useLocation();
  const hasNotifications = notifications.length > 0;

  return (
    <div className="notifications-popover">
      <div className="notifications-popover-header">
        <div>
          <div className="notifications-popover-title">
            <FormattedMessage id="notificationsPopover.title" />
          </div>
          <div className="notifications-popover-subtitle">
            {unreadCount > 0 ? (
              <FormattedMessage id="notificationsPopover.newMessages" values={{ count: unreadCount }} />
            ) : (
              <FormattedMessage id="notificationsPopover.noNewMessages" />
            )}
          </div>
        </div>
        {hasNotifications && (
          <Link to={notificationsUrl} state={{ from: location.pathname }} onClick={onClose} className="notifications-popover-see-all-link">
            <FormattedMessage id="notificationsPopover.seeAll" />
          </Link>
        )}
      </div>

      <div className="notifications-popover-list">
        {hasNotifications ? (
          notifications.map((notification) => (
            <PopoverNotificationItem key={notification.key} notification={notification} onClick={onNotificationClick} />
          ))
        ) : (
          <div className="notifications-popover-empty">
            <FormattedMessage id="notificationsPopover.empty" />
          </div>
        )}
      </div>

      <div className="notifications-popover-footer">
        {hasNotifications && (
          <Link to={notificationsUrl} state={{ from: location.pathname }} onClick={onClose}>
            <Button type="primary" className="notifications-popover-footer-button">
              <FormattedMessage id="notifications.see.all" />
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default NotificationsPopoverContent;
